{
    "coordinates": [
        23.933455300493094,
        81.3862506415166
    ],
    "tooltip": "Tiki",
    "title": "Tiki Formation",
    "country": "India",
    "period": "Triassic",
    "alt": "TODO"
}